/* The backend is chosen from the domain the app is opened on (see ./config.js):
   localhost -> local servers, *.rril.ril.com -> rril server, anything else -> production. */
import { SERVER_PATH, SERVER_PATH_FOR_OMS } from './config'


export const API_LOGIN_INFORMATION = `${SERVER_PATH}/users/authenticate`
export const API_GET_STORE_LIST = `${SERVER_PATH}/stores`
export const API_ALL_GET_STORE_LIST = `${SERVER_PATH}/superStores/getAllStoresList`
export const API_GET_CITY_LIST = `${SERVER_PATH}/superStores/CityList`
export const API_GET_SUPER_CITY_LIST = `${SERVER_PATH}/superStores/CityList`
export const API_GET_STORE_CITY_LIST = `${SERVER_PATH}/superStores/StoreList`
export const API_GET_SUPER_STORE_CITY_LIST = `${SERVER_PATH}/superStores/StoreList`
export const API_GET_STATE_LIST = `${SERVER_PATH}/superStores/StateList`
export const API_GET_SUPER_STATE_LIST = `${SERVER_PATH}/superStores/StateList`
export const API_POST_ADD_STORE_DATA = `${SERVER_PATH}/superStores/addStore`
export const API_DELETE_STORE_BY_ID = `${SERVER_PATH}/superStores/deleteById`
export const API_GET_STORE_BY_ID = `${SERVER_PATH}/superStores/storeById`
export const API_GET_SUPER_STORE_BY_ID = `${SERVER_PATH}/superStores/storeById`
export const API_LOGOUT_INFORMATION = `${SERVER_PATH}/users/logout`
export const API_IS_USER_LIVE = `${SERVER_PATH}/users/checkUserIsLive`
export const API_GET_CITY_LIST_BY_STATE = `${SERVER_PATH}/superStores/getCityListByState`
export const API_UPDATE_BULK_STORE_DATA = `${SERVER_PATH}/superStores/bulkCsvUploadUpdate`
export const API_UPDATE_BULK_STORE_MASTER_DATA = `${SERVER_PATH}/superStoreUsers/bulkCsvUploadUpdate`
export const API_ALL_CAMPAIGN_EVENT_LIST = `${SERVER_PATH}/superLeads/getAllCampaignEvent`
export const API_GET_USERS_LIST = `${SERVER_PATH}/superusers/usersList`
export const API_VERIFY_USER_EMAIL = `${SERVER_PATH}/superusers/verifyEmail`
export const API_GET_USER = `${SERVER_PATH}/superusers/user`
export const API_REGISTER_USER = `${SERVER_PATH}/superusers/register`
export const API_UPDATE_USER = `${SERVER_PATH}/superusers/updateById`
export const API_DLETE_USER_BY_ID = `${SERVER_PATH}/superusers/deleteById`
export const API_ALL_NSO_EVENT_LIST = `${SERVER_PATH}/superLeads/getAllnsoCampaignEvent`
export const API_UPDATE_PASSWORD = `${SERVER_PATH}/superusers/updatePassword`
export const API_GENERATE_QR_CODE = `${SERVER_PATH}/supermanages/generateQrCode`
export const API_DELETE_QR_CODE_BY_ID = `${SERVER_PATH}/supermanages/qrCodeDelete`
export const API_UPDATE_BULK_BARCODE_DATA = `${SERVER_PATH}/supermanages/bulkCsvUploadBarcode`
export const API_UPDATE_BARCODE_DATA = `${SERVER_PATH}/supermanages/updateQrCode`


//nach list
export const API_ALL_GET_NACH_LIST = `${SERVER_PATH}/superNachs/getAll`
export const API_GET_NACH_By_Id = `${SERVER_PATH}/superNachs/getById`
export const API_UPDATE_NACH_By_Id = `${SERVER_PATH}/superNachs/getById`
export const API_POST_NACH = `${SERVER_PATH}/superNachs/`

//lead generation 

export const API_GET_LEAD_GENERATION_LIST = `${SERVER_PATH}/superLeads/getAll`
export const API_GET_RANNKAAR_LIST = `${SERVER_PATH}/superLeads/getAllLeaflet`
export const API_GET_PREBOOK_LIST = `${SERVER_PATH}/superLeads/getAllPrebookInfo`
export const API_GET_MAKE_TO_ORDER_JH_LIST = `${SERVER_PATH}/superLeads/getAllMakeToOrderList`
export const API_GET_PREBOOK_DETAILS = `${SERVER_PATH}/superLeads/getAllPrebookById`
export const API_UPDATE_PREBOOK_DETAILS = `${SERVER_PATH}/superLeads/updatePrebookById`
export const API_CALLBACK_LIST = `${SERVER_PATH}/superLeads/getAllCallback`
export const API_APPOINTMENT_LIST = `${SERVER_PATH}/superLeads/getAllAppointment`
export const API_CALLBACK_USER_LIST = `${SERVER_PATH}/superLeads/getAllCallbackUsers`
export const API_APPOINTMENT_USER_LIST = `${SERVER_PATH}/superLeads/getAllAppointmentUsers`
export const API_STORE_MASTER_LIST = `${SERVER_PATH}/superStoreUsers/getAll`
export const API_STORE_MASTER_Login_LIST = `${SERVER_PATH}/superStoreUsers/getLoginHistory`
export const API_STORE_MASTER_BY_ID = `${SERVER_PATH}/superStoreUsers/getById`
export const API_UPDATE_STORE_MASTER_DATA = `${SERVER_PATH}/superStoreUsers/updateById`
export const API_ADD_STORE_MASTER_DATA = `${SERVER_PATH}/superStoreUsers/signup`
export const API_ADD_GOLD_RATE = `${SERVER_PATH}/superLeads/createGoldRate`
export const API_GET_GOLD_RATE_LIST = `${SERVER_PATH}/superLeads/getGoldRateList`
export const API_GET_LIKE_PRODUCT_LIST = `${SERVER_PATH}/superLeads/getLikeDisLikeProductInfo`
export const API_GET_TRY_ON_VIDEO_ASSISTANCE_LIST = `${SERVER_PATH}/superLeads/liveAssistanceStore`
export const API_GET_MAKE_TO_ORDER_JEWELS_LIST = `${SERVER_PATH}/superLeads/makeToOrderRj`
export const API_GET_FEEDBACK_LIST = `${SERVER_PATH}/superLeads/feedbackList`
export const API_GET_WISH_LIST = `${SERVER_PATH}/superLeads/wishList`
export const API_GET_QR_CODE_LIST = `${SERVER_PATH}/supermanages/getAllQrCode`
export const API_GET_SCAN_BAR_CODE_LIST = `${SERVER_PATH}/supermanages/getAllScanBarCode`
export const API_GET_BARCODE_DETAILS_BY_ID = `${SERVER_PATH}/supermanages/qrCodeDetails`
export const API_POST_JH_FEEDBACK = `${SERVER_PATH}/supermanages/postJhFeedback`
export const API_GET_JH_FEEDBACK_LIST = `${SERVER_PATH}/supermanages/feedbackJhList`
export const API_GET_FESTIVE_FEEDBACK_LIST = `${SERVER_PATH}/supermanages/festiveFeedback`
export const API_GET_FEEDBACK_AD_LIST = `${SERVER_PATH}/supermanages/festiveAd`
export const API_GET_NPS_LIST = `${SERVER_PATH}/supermanages/npsFeedback`
export const API_ADD_CALL_SLOT = `${SERVER_PATH}/supermanages/callSlot`


//oms list
export const API_ORDER_LIST = `${SERVER_PATH_FOR_OMS}/public/getAll`
export const API_ORDER_DETAILS = `${SERVER_PATH_FOR_OMS}/public/getOrderDetails`
export const API_ORDER_TRACKING = `${SERVER_PATH_FOR_OMS}/public/getOrderTrackingDetails`
export const API_RJ_TOTAL_USERS_LIST = `${SERVER_PATH_FOR_OMS}/public/getTotalCustomerDetails`
export const API_RJ_TOTAL_SALE_LIST = `${SERVER_PATH_FOR_OMS}/public/getTotalSalesDetails`
export const API_RJ_CUSTOMER_CART_DETAILS = `${SERVER_PATH_FOR_OMS}/public/getTotalCustomerCartDetails`
export const API_GET_JH_LIVE_SKU_COUNT = `${SERVER_PATH}/supermanages/liveSkuCount`
export const API_GET_JH_LIVE_DESIGN_COUNT = `${SERVER_PATH}/supermanages/liveDesignCount`
export const API_SEND_OTP = `${SERVER_PATH}/superStoreUsers/generateOtp`
export const API_VERIFY_OTP = `${SERVER_PATH}/storeusers/verifyOtp`


//Sales Report Data
export const API_GET_SALES_REPORT_DATA = `${SERVER_PATH_FOR_OMS}/public/getSalesReport`
export const API_GET_SALES_REPORT_JEWELSHUB_DATA = `${SERVER_PATH}/superLeads/getSalesReportJewelshub`
export const API_GET_SALES_REPORT_RJ_DATA = `${SERVER_PATH}/superLeads/getSalesReportRj`
export const API_GET_CTA_LIST = `${SERVER_PATH}/supermanages/getCTA`

